import TextManagement from './TextManagement';

export default TextManagement;
